// extracted by mini-css-extract-plugin
export default {"fullWidth":"cq-z","image":"dq-z","lazyLoadPicture":"eq-z","lazyLoadSpinner":"fq-z","lazyLoadSpin":"gq-z","lazyLoadImage":"hq-z","hasStyledAspectRatio":"iq-z"};